module.exports = __webpack_public_path__ + "static/img/smartControl21.aade5226.png";